import { mapCollection } from '../../utils/collection.utils';
import { Language } from '../language';

export class LanguageBuilder {
  static fromJson(json) {
    return (json)
      ? new Language(
        json.hash,
        json.name,
        json.locale
      )
      : null;
  }

  static fromList(list) {
    return (Array.isArray(list)) ? mapCollection(LanguageBuilder.fromJson, list) : [];
  }
}
